import {GroupGLTERM} from 'ApplicationEntry/models/ProductsRiders/GLTERM/GroupGLTERM';
import {NewYorkGLTERM} from 'ApplicationEntry/models/ProductsRiders/GLTERM/NewYorkGLTERM';
import {OrdGLTERM} from 'ApplicationEntry/models/ProductsRiders/GLTERM/OrdinaryGLTERM';

export type GLTERM = OrdGLTERM | GroupGLTERM | NewYorkGLTERM;

type ExhaustiveGLTERMOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdGLTERM) => TReturn;
  Group: (group: GroupGLTERM) => TReturn;
  NewYork: (newYork: NewYorkGLTERM) => TReturn;
};

type PartialGLTERMOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdGLTERM) => TReturn;
  Group?: (group: GroupGLTERM) => TReturn;
  NewYork?: (newYork: NewYorkGLTERM) => TReturn;
  _: (app: GLTERM) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: GLTERMByTypeOptions<TReturn>
): options is ExhaustiveGLTERMOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type GLTERMByTypeOptions<TReturn> = PartialGLTERMOptionsByType<TReturn> | ExhaustiveGLTERMOptionsByType<TReturn>;

export const matchGLTERMByType = <TReturn>(options: GLTERMByTypeOptions<TReturn>) => (app: GLTERM): TReturn => {
  switch (app.key) {
    case 'InvalidOrdGLTERM':
    case 'ValidOrdGLTERM':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupGLTERM':
    case 'ValidGroupGLTERM':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkGLTERM':
    case 'ValidNewYorkGLTERM':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidGLTERM = (glterm: GLTERM) =>
  glterm.key === 'ValidOrdGLTERM' || glterm.key === 'ValidGroupGLTERM' || glterm.key === 'ValidNewYorkGLTERM';

export const typeList = ['Employee', 'Spouse', 'Child', 'Other'];

export const planList = [
  {name: 'GLTERM', displayName: 'GLTERMSI'},
  {name: 'SGLTERM', displayName: 'GLTERMCGI'},
  {name: 'GIGLTERM', displayName: 'GLTERMGI'},
];
export const smokerValues = ['Smoker', 'Non Smoker'];

export const isSpouse = (type: string) => {
  return type === 'Spouse';
};
